<template>
    <div :class="['modal-container', { active: active }]">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" background-color="#EBF9FF"
            color="#02B99E">
        </loading>
        <div class="card head-card news">
            <div class="title-card">
                <h4>Agregar newsletter</h4>
                <button class="touchpad" @click="close">x</button>
            </div>
            <div class="card-content">
                <div class="item">
                    <!-- <div class="card-content"> -->
                    <div class="row justify-content-center">
                        <div class="col-sm-12 col-md-8 mb-1 justify-content-center">
                            <div class="inputype Keywords-input">
                                <form>
                                    <h4 class="interiorTitle">Nombre</h4>
                                    <input type="text " v-model="form.nombre" placeholder="Nombre" />
                                </form>
                            </div>
                            <!-- </div> -->
                        </div>
                        <div class="col-sm-12 col-md-8 mb-1 justify-content-center mt-2">
                            <div class="Keywords-button-container">
                                <button :class="[
                                    'button',
                                    'fluid',
                                    'alternative',
                                    'noMargin',

                                ]" @click="guardarCambios()">
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["close", "active","reload", "edit","name", "id"],
    data() {
        return {
            isLoading: false,
            url: this.$store.getters.getMainUrl,
            form: {
                nombre: "",
                titulo: "",
                color: "#cbd5e0",
                file: null,
                url: "",
                key: this.$store.state.userInfo.id,
                height: 0,
                width: 0,
                lista: [],
                editar:this.edit,
                name:""
            },
            defaultForm: {
                nombre: "",
                titulo: "",
                color: "#cbd5e0",
                file: null,
                url: "",
                key: this.$store.state.userInfo.id,
                height: 0,
                width: 0,
                lista: [],
                editar:this.edit,
                name:""
            },
        };
    },
    mounted(){
        if(this.edit){
            this.form.nombre = this.name;
            this.form.name = this.name;
            this.form.id = this.id;
        }
    },
    methods: {
        async guardarCambios() {
            this.isLoading = true;
            await axios
                .post(
                    this.url + "crearnewsletter",
                    this.form
                )
                .then((response) => {
                    if (response.data.success) {

                        this.success(response.data.body);
                        this.form = Object.assign({}, this.defaultForm);
                        this.close();
                        this.reload();


                    } else {

                        this.error(response.data.body);

                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.isLoading = false;
        },
        success(msg) {
            this.$snotify.success(msg, this.$store.state.success);
        },
        error(msg) {
            this.$snotify.error(msg, this.$store.state.error);
        },
    },
};
</script>